<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单号</label>
            <em class="weui-form-preview__value">{{ form.main.ct_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="ct_vendname">
            <label class="weui-form-preview__label">{{ customLabel.ct_vendname || "报备原厂" }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ct_vendname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ct_date">
            <label class="weui-form-preview__label">{{ customLabel.ct_date || "报备日期" }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ct_date
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ct_custname">
            <label class="weui-form-preview__label">{{ customLabel.ct_custname || "客户名称" }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ct_custname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ct_industry">
            <label class="weui-form-preview__label">{{ customLabel.ct_industry || "行业类型" }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ct_industry
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ct_result">
            <label class="weui-form-preview__label">{{ customLabel.ct_result || "原厂态度" }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ct_result
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ct_remark">
            <label class="weui-form-preview__label">{{ customLabel.ct_remark || "报备说明" }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ct_remark
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="creatorName">
            <label class="weui-form-preview__label">{{ customLabel.creatorName || "录入人" }}</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ct_auditman">
            <label class="weui-form-preview__label">{{ customLabel.ct_auditman || "审核人" }}</label>
            <span class="weui-form-preview__value">{{
              form.main.ct_auditman
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ct_auditdate">
            <label class="weui-form-preview__label"> {{ customLabel.ct_auditdate || "审核日期" }}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.ct_auditdate
            }}</span>
          </div>
        </custom-layout>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/crm/client_put_edit?id=' + form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        >编辑</router-link
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
        >审核</a
      >
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
        >删除</a
      >
      <!-- <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
      >反审</a> -->
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";

export default {
  mixins: [process],
  components: {
    CustomLayout,
  },
  data() {
    return {
      baseUrl: "/api/crm/clientput",
      codeField: "ct_code",
      statusField: "ct_statuscode",
      caller: "ClientPut",
      xtype: "crm-clientput-formpanel",
    };
  },
};
</script>